import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { AnimatedImageView, component } from '@serviceos-rn/core';
import { TipConfig } from '../../../TipConfig';
import { AVATAR_URL } from '../../../Constants/Constants';
import { TipConfiguration } from '../../../Domain/DTOs/TipConfigurationDTO';
export const AvatarView = component({
    provider: TipConfig.provider,
    moduleName: TipConfig.moduleName,
    componentName: TipConfiguration.ComponentNames.avatar,
    style(theme, mediaQuery, window, props) {
        return {
            container: Object.assign({ height: props.imageSize || 80, width: props.imageSize || 80, borderRadius: 100, overflow: 'hidden', backgroundColor: '#fff', borderWidth: 1, borderColor: '#fff', borderStyle: 'solid' }, props.containerStyle)
        };
    }
})(({ style, image, size = 'normal', assets }) => {
    var _a, _b, _c, _d;
    const [avatar, setAvatar] = useState(image || ((_a = assets === null || assets === void 0 ? void 0 : assets.images) === null || _a === void 0 ? void 0 : _a.avatar_url) || AVATAR_URL);
    const handleError = useCallback(() => {
        var _a, _b, _c;
        if (((_a = assets === null || assets === void 0 ? void 0 : assets.images) === null || _a === void 0 ? void 0 : _a.avatar_url) && avatar === ((_b = assets === null || assets === void 0 ? void 0 : assets.images) === null || _b === void 0 ? void 0 : _b.avatar_url)) {
            return;
        }
        setAvatar(((_c = assets === null || assets === void 0 ? void 0 : assets.images) === null || _c === void 0 ? void 0 : _c.avatar_url) || AVATAR_URL);
    }, [avatar, (_b = assets === null || assets === void 0 ? void 0 : assets.images) === null || _b === void 0 ? void 0 : _b.avatar_url]);
    if (!avatar) {
        return null;
    }
    return (_jsx(AnimatedImageView, { image: avatar, onError: handleError, resizeMode: "cover", containerStyle: Object.assign(Object.assign({}, style === null || style === void 0 ? void 0 : style.container), size === 'small' && {
            width: ((_c = style === null || style === void 0 ? void 0 : style.container) === null || _c === void 0 ? void 0 : _c.width) - 10,
            height: ((_d = style === null || style === void 0 ? void 0 : style.container) === null || _d === void 0 ? void 0 : _d.height) - 10
        }) }));
});
